import constants from '../shared/constants';
import axios from 'axios';
// Add a request interceptor
const interceptor = async (Authorization, token) => {
  return await axios.interceptors.request.use(
    config => {
      if (Authorization) config.headers.Authorization = Authorization;
      else if (token) config.headers.Authorization = `${constants.AUTHETICATE_TYPE.BEARER} ${token}`;
      return config;
    },
    error => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        axios.defaults.headers.common.Authorization = `${constants.AUTHETICATE_TYPE.BEARER} ${token}`;
        return axios(originalRequest);
      }
      return Promise.reject(error);
    });
};

export default interceptor;
